import { useState } from 'react';

import { TariffClassificationApiModel, TariffSectionApiModel } from '~/lib/api/smartsend/types';
import { FixedColumn } from '../FixedColumn';
import { Expansion } from './Expansion';
import { TariffChapter } from './TariffChapter';
import { P2GBox, P2GText, P2GLink, P2GFade } from '@parcel2go/core-ui';

interface props {
  section: TariffSectionApiModel;
  getClassifications: (code: string) => Promise<TariffClassificationApiModel[]>;
  selectCode: (code: string) => void;
  selectSection: (sectionId: string | null) => void;
  canSelect: boolean;
}

const TariffSection: React.FC<props> = (props) => {
  const [open, setOpen] = useState(false);
  const sectionIds = props.section.Chapters.map((x) => x.Code).sort();

  function selectSection() {
    setOpen(!open);
    props.selectSection(open ? null : props.section.Id);
  }

  return (
    <P2GBox mb={1} textAlign="left">
      <P2GBox bordered p={1}>
        <FixedColumn
          left={
            <P2GText>
              {sectionIds.length == 1 ? (
                <strong>{sectionIds[0]}</strong>
              ) : (
                <strong>
                  {sectionIds[0]} - {sectionIds[sectionIds.length - 1]}
                </strong>
              )}
            </P2GText>
          }
          right={
            <P2GLink underline="always" onClick={selectSection}>
              <strong>{props.section.Name}</strong>
            </P2GLink>
          }
          width={60}
        />
      </P2GBox>
      {open && (
        <Expansion mt={1}>
          {props.section.Chapters.map((c) => (
            <P2GBox mb={1} key={c.Id}>
              <P2GFade in>
                <TariffChapter
                  canSelect={props.canSelect}
                  selectCode={props.selectCode}
                  chapter={c}
                  getClassifications={props.getClassifications}
                />
              </P2GFade>
            </P2GBox>
          ))}
        </Expansion>
      )}
    </P2GBox>
  );
};

export { TariffSection };
